import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import {   useTask, TasksDispatchContext } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";
import {
    IAdequacy,
    IAssessment,
    IAssessmentProject,
    IAssessmentTemplateGroup, IControlMeasure,
    IControlMeasureAssessment, IControlMeasureCost,
    ISummaryKnowledge, ISummaryTotalKnowledge
} from "../types/types";

import {
    Accordion,
    AccordionSummary,
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";
import { useParams } from "react-router";
import SummaryKnowledge from "./summary_knowledge";
import TotalSummaryKnowledge from "./total_knowledge_summary";
import total_knowledge_summary from "./total_knowledge_summary";
import { API_URL } from "../env";

interface ISummaryKnowledgeProps {

}

interface IRouteParams {
    id: string
}



const SummaryKnowledges: FC<ISummaryKnowledgeProps> = () => {
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [totalSummary, setTotalSummary] = useState<ISummaryTotalKnowledge>({})
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const params = useParams<IRouteParams>()

    const [assessment, setAssessment] = useState<IAssessmentProject>();
    const [topLevelGroup, setTopLevelGroup] = useState<IAssessmentTemplateGroup[]>([]);
    const [assessments, setAssessments] = useState<IAssessment[]>([]);

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    useEffect(() => {

        if (tasks.loaded) {

            setAssessment(tasks.projectAssessment)
            setAssessments(tasks.projectAssessments)
            setAdequacies(tasks.adequacies)
            setTopLevelGroup(tasks.templateGroups)
            setTotalSummary(tasks.summaryTotalKnowledge)
            setIsLoaded(true)

        }

    })


    const setSummaryKnowledge = async (summaryKnowledge: ISummaryKnowledge) => {
        delete summaryKnowledge.id
        return await post<ISummaryKnowledge>(API_URL + "summary_assessment/" + params.id.toString(), summaryKnowledge);
    }

    const postSummaryTotalKnowledge = async (summaryKnowledge: ISummaryTotalKnowledge) => {
        delete summaryKnowledge.id
        return await post<ISummaryTotalKnowledge>(API_URL + "summary_assessment/" + params.id.toString() + "/summary", summaryKnowledge);
    }

    const updateSummaryKnowledge = useCallback((summaryKnowledge: ISummaryKnowledge) => {
        delete summaryKnowledge.id
        delete summaryKnowledge.group

        setSummaryKnowledge(summaryKnowledge).then(() => {
            setReload(true);
        })
    }, [setSummaryKnowledge, setReload]);

    const updateTotalSummaryKnowledge = useCallback((summaryKnowledge: ISummaryTotalKnowledge) => {
        delete summaryKnowledge.id
        delete summaryKnowledge.adequacy

        postSummaryTotalKnowledge(summaryKnowledge).then(() => {
            setReload(true);
        })
    }, [setSummaryKnowledge, setReload]);



    // useEffect(() => {
    //     if (!isLoaded && !isLoading) {
    //         setIsLoading(true)

    //         getSummaryKnowledge().then(
    //             () => {
    //                 getTotalSummaryKnowledge().then(
    //                     () => {

    //                         setIsLoading(false)
    //                         setIsLoaded(true)
    //                     }
    //                 )
    //             }
    //         )
    //     }


    //     if (reload) {
    //         getSummaryKnowledge().then(
    //             () => {
    //                 setReload(false)

    //             })
    //     }
    // }, [isLoaded,  getSummaryKnowledge, reload, setReload])

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    return (
        <>
            <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="1%" ></TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>State of Knowledge</TableCell>
                            <TableCell>Missing Information</TableCell>
                            <TableCell>Comments</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoaded && topLevelGroup.map((tp, index) => {
                            return <SummaryKnowledge
                                topLevelGroup={tp}
                                assessments={assessments}
                                updateSummaryKnowledge={updateSummaryKnowledge} />
                        })}
                        {isLoaded && <TotalSummaryKnowledge totalSummary={totalSummary}
                            updateSummaryKnowledge={updateTotalSummaryKnowledge}
                            adequacies={adequacies} />}
                    </TableBody>

                </Table>


            </Paper>
        </>
    );
}

export default SummaryKnowledges;
